import { db } from '../config/firebase';
import { collection, doc, setDoc, onSnapshot, query, orderBy, limit, serverTimestamp } from 'firebase/firestore';

const COL = 'pegatinas_estado';
// `pegatinas_estado` crece 1 doc por pegatina impresa. El overlay "¿impresa?"
// solo necesita las recientes — 3000 cubre de sobra cualquier conjunto de
// órdenes activas a la vista.
const LIMITE_PEGATINAS = 3000;

export const marcarPegatina = (referencia, datos) => {
  const docId = referencia.replace(/[^a-zA-Z0-9]/g, '_');
  return setDoc(doc(db, COL, docId), {
    referencia,
    ordenId:      datos.ordenId  ?? null,
    cliente:      datos.cliente  ?? null,
    tecnico:      datos.tecnico  ?? null,
    tipo:         datos.tipo     ?? null,
    fechaPegatina: serverTimestamp(),
  }, { merge: true });
};

export const subscribePegatinas = (callback) => {
  const q = query(collection(db, COL), orderBy('fechaPegatina', 'desc'), limit(LIMITE_PEGATINAS));
  return onSnapshot(q, (snap) => {
    const records = {};
    snap.forEach(d => {
      const data = d.data();
      if (data.referencia) records[data.referencia] = data;
    });
    callback(records);
  });
};
